import asyncJob from './asyncJob';
import auth from './auth';
import subscription from './subscription';
import user from './user';
import parkLogs from './parkLogs';
import parkReport from './parkReport';
import resort from "./resort";
import feature from "./feature";
import gis from "./gis";
import importApi from "./import";
import logbook from "./logbook";
import trail from "./trail";
import terrainPark from "./terrainPark";
import restrictedContent from './restrictedContent';
import officialRequest from './officialRequest';
import invitation from './invitation';
import feedback from './feedback';
import redirect from './redirect';
import form from './form';
import tag from './tag';
import formFolder from './formFolder';
import formResponse from "./formResponse";
import trailIssueForm from './trailIssueForm';
import trailIssueFormResponse from "./trailIssueFormResponse";
import widgetKey from './widgetKey';
import userGroup from './userGroup';
import roles from './roles';
import roleDefinitions from './roleDefinitions';
import calendar from './calendar';
import notificationConfig from './notificationConfig';
import apiKey from './apiKey';
import adminPushNotification from './adminPushNotification';
import packs from './packs';

const rollUp = {
  asyncJob,
  auth,
  subscription,
  user,
  parkLogs,
  parkReport,
  resort,
  feature,
  gis,
  import: importApi,
  logbook,
  trail,
  terrainPark,
  restrictedContent,
  officialRequest,
  invitation,
  feedback,
  redirect,
  form,
  tag,
  formFolder,
  formResponse,
  trailIssueForm,
  trailIssueFormResponse,
  widgetKey,
  userGroup,
  roles,
  roleDefinitions,
  calendar,
  notificationConfig,
  apiKey,
  adminPushNotification,
  packs,
};

export default rollUp;